import React from 'react';
import { FormattedTime } from 'react-intl';

import useFormatTimeTimeZone from 'hooks/useFormatTimeTimeZone';
import { TIME_FORMAT } from 'utils/dateFormats';

import type { StandardDateProps as StandardTimeProps } from './StandardDate';

const StandardTime: React.FC<StandardTimeProps> = ({ value, dealerId, systemTimezone }) => {
  const timeZoneProps = useFormatTimeTimeZone({ dealerId, systemTimezone });
  if (!value) {
    return null;
  }
  return (
    // eslint-disable-next-line no-restricted-syntax
    <FormattedTime value={value} {...TIME_FORMAT} {...timeZoneProps} />
  );
};

export default StandardTime;
